import Typography from '@mui/material/Typography'
import styled from '@mui/material/styles/styled'

export const Title = styled(Typography, {
  name: 'Title',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro Semibold';
  font-size: 20px;
  line-height: 160%;
  color: theme.palette.text.primary;
`
